
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const ParcelDelivery = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="ParcelDelivery" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M12 2H1v8h11zm-1 7H2V3h9zm-.5 4a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5zm0 2a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-7-2A1.5 1.5 0 105 14.5 1.5 1.5 0 003.5 13zm0 2a.5.5 0 11.5-.5.5.5 0 01-.5.5zM16 0v1h-2v11H0v-1h13V0z" />
</svg>
    </HvIconBase>
)};

ParcelDelivery.propTypes = HvIconBase.propTypes;

export default ParcelDelivery;